import React, { useContext, useState, useEffect, useCallback } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Localbase from "localbase";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../data/ENDPOINT";
import axios from "axios";

const db = new Localbase("db");

const ChatPopUp = ({ account }) => {
    const { user } = useContext(AuthContext);
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCourse = async () => {
            try {
                const data = account && account.purchases ? account.purchases : [];
                if (data && data.length > 0) {
                    setCourse(data[data.length - 1]);
                }
            } catch (error) {
                console.error("Error fetching course:", error);
            }
        };

        fetchCourse();
    }, [account]);

    // Send WhatsApp request
    const sendRequest = useCallback(async () => {
        if (!user || !course) return;

        setLoading(true); // Set loading to true when request starts

        try {
            const formData = new FormData();
            formData.append("session", user.SessionId);
            formData.append("subject", "Chat with us via WhatsApp");
            formData.append("message", "Chat with us via WhatsApp");
            formData.append("course", course.course_url || "");
            formData.append("batch_id", course.batch_id || "");
            formData.append("category", "chat");

            const res = await axios.post(`${ENDPOINT}whatsapp-chat.php`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (res.data.status === "success") {
                const { discussion_id } = res.data;
                window.open(
                    `https://wa.me/919490174876?text=*Discussion%20ID*:%20${discussion_id}%20*Course%20ID*:%20${course.course_url}%20*Batch%20ID*:%20${course.batch_id}`
                );
            }
        } catch (error) {
            console.error("Error sending request:", error);
        } finally {
            setLoading(false); // Reset loading state after request completes
        }
    }, [user, course]);

    return (
        <div className="fixed-chat-popup  justify-content-end d-flex animate-fadeInUp">
            {course ? (
                <button
                    onClick={sendRequest}
                    className="home d-flex p-2 px-2 px-md-3 p-md-2 m-0 rounded rounded-pill border-0"
                    disabled={loading} // Disable button during loading
                >
                    <div className="d-flex text-success pe-0 pe-md-1 align-items-center">
                        <WhatsAppIcon className="me-0 me-md-2" />
                        <h6 className="text-light d-none d-md-block">
                            {loading ? (
                                <span>
                                    Requesting... <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </span>
                            ) : (
                                "Chat with us"
                            )}
                        </h6>
                    </div>
                </button>
            ) : (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://api.whatsapp.com/send/?phone=919490174876&text=Hello&type=phone_number&app_absent=0"
                >
                    <button className="home d-flex p-2 px-2 px-md-3 p-md-2 m-0 rounded rounded-pill border-0">
                        <div className="d-flex text-success pe-0 pe-md-1">
                            <WhatsAppIcon className="me-0 me-md-2" />
                            <h6 className="text-light d-none d-md-block">Chat with us</h6>
                        </div>
                    </button>
                </a>
            )}
        </div>
    );
};

export default ChatPopUp;